import { useTranslation } from 'react-i18next'
import { FormikProvider } from 'formik'
import {
  Box,
  Button,
  DialogActions,
  DialogContent,
  FormControl,
  FormControlLabel,
  Grid,
  Radio,
  RadioGroup,
  Typography,
} from '@mui/material'

import { TimePeriodExclusionEnum } from '@/enums'
import { useResponsibleGamingForms } from '@/views/player-card/hooks'
import InputFormikField from '@/views/components/input-formik-field/index.component'

import InputFormikCheckbox from '@/views/components/input-formik-checkbox/index.component'

export const RGCoolOffForm = () => {
  const { t } = useTranslation()

  const { formikRGCoolOff, handleSubmitRGCoolOff, handleCloseDialog } =
    useResponsibleGamingForms()

  return (
    <>
      <DialogContent>
        <FormikProvider value={formikRGCoolOff}>
          <Grid container spacing={2} sx={{ p: 1 }}>
            <Grid item xs={12}>
              <Typography fontWeight={700} variant="body2">
                {`${t('playerCard.assignCoolOff')}:`}
              </Typography>
              <FormControl margin="dense">
                <RadioGroup
                  row
                  name="timePeriod"
                  value={formikRGCoolOff.values.timePeriod}
                  onChange={(event) =>
                    formikRGCoolOff.setFieldValue(
                      'timePeriod',
                      event.target.value,
                    )
                  }
                  sx={{ display: 'flex', flexDirection: 'column', pl: 2 }}
                >
                  {Object.values(TimePeriodExclusionEnum)
                    .filter(
                      (timePeriodType) =>
                        timePeriodType !== TimePeriodExclusionEnum.PERMANENTLY,
                    )
                    .map((timePeriodType) => {
                      return (
                        <FormControlLabel
                          value={timePeriodType}
                          control={<Radio color="primary" />}
                          label={t(`timePeriodTypeOptions.${timePeriodType}`)}
                          labelPlacement="end"
                        />
                      )
                    })}
                </RadioGroup>
              </FormControl>
            </Grid>
            {formikRGCoolOff.values.timePeriod ===
              TimePeriodExclusionEnum.SPECIFIC_DATE && (
              <Grid item xs={12}>
                <InputFormikField
                  label={t('labels.specificDate')}
                  name="specificDate"
                  isDatePicker
                />
              </Grid>
            )}
            <Grid item xs={12}>
              <Box sx={{ pl: 2 }}>
                <InputFormikCheckbox
                  label={t('playerCard.sendNotification')}
                  name="sendNotification"
                />
              </Box>
            </Grid>
          </Grid>
        </FormikProvider>
        <DialogActions sx={{ padding: '10px 0px' }}>
          <Button onClick={handleCloseDialog} className="red">
            {t('labels.cancel')}
          </Button>
          <Button
            disabled={!(formikRGCoolOff.isValid && formikRGCoolOff.dirty)}
            variant="contained"
            onClick={handleSubmitRGCoolOff}
          >
            {t('labels.update')}
          </Button>
        </DialogActions>
      </DialogContent>
    </>
  )
}
